import * as React from 'react';

import {
  TokenListInput,
  type TokenListInputProps,
  type TokenProps,
  StringListInput,
  type StringListInputProps,
  ValueListInput,
  type ValueListInputProps,
} from './new-stuff';
import FilledToken from './filled-token';

// option prop is optional, see type TokenProps<V> in new-stuff.jsx
// the real signature here should be some variant of TokenProps where
// V includes color optionally
const ColorToken = (
  props: TokenProps<{
    color?: string;
  }>,
) => <FilledToken pillColor={props.option?.color} {...props} />;

const sharedProps = {
  showValuesOutside: true,
  allowArbitraryValues: false,
  searchOnEmptyString: true,
  searchable: true,
} as const;

const selectListProps = {
  ...sharedProps,
  components: {
    Token: ColorToken,
  },
} as const;

const SelectList = <T extends unknown>(props: TokenListInputProps<T>) => (
  // @ts-expect-error - TS2322 - Type '{ values: T[]; onChange: (arg1: T[]) => unknown; inputProps?: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> | undefined; ... 32 more ...; disabled?: unknown; }' is not assignable to type '{ values: T[]; onChange: (arg1: T[]) => unknown; inputProps?: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> | undefined; ... 13 more ...; autofocus?: boolean | undefined; }'.
  <TokenListInput {...selectListProps} {...props} />
);

export default SelectList;

export const StringSelectList = (props: StringListInputProps) => (
  <StringListInput {...sharedProps} {...props} />
);

export const ValueSelectList = <T extends unknown>(
  props: ValueListInputProps<T>,
) => <ValueListInput {...sharedProps} {...props} />;
